export enum ImageExtension {
  'png',
  'jpeg',
  'jpg',
  'gif',
  'bmp',
}
